import { useEffect, useRef, useState } from "react";
import { useSettings } from "./useSettings";

const PaypalApiUrl = "https://www.paypal.com/sdk/js?client-id=";
let skip;

export const usePaypalApi = () => {
  const { paypal: settings } = useSettings();
  const [paypal, setPaypal] = useState(window.paypal);
  const mounted = useRef(true);

  useEffect(() => {
    const source = settings?.live?.clientId ? settings.live : settings?.test;
    const { clientId } = source || {};

    if (clientId && !window.paypal && !skip) {
      skip = true;
      const s = document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.defer = true;
      s.onload = () => {
        if (mounted.current) {
          setPaypal(window.paypal);
        }
      };
      s.src = PaypalApiUrl + clientId;
      document.getElementsByTagName("HEAD")[0].appendChild(s);
    }

    return () => {
      mounted.current = false;
    };
  }, [settings, mounted]);

  useEffect(()=>{
    const i = setInterval(()=>{
      if (window.paypal) {
        setPaypal(window.paypal);
        clearInterval(i);
      }
    }, 500);

    return () => {
      clearInterval(i);
    }
  }, [setPaypal]);

  return paypal;
};
